export interface Edit {
  partnerDemandedMinimumMarginAbs: string;
  partnerRelativeDemandedMinimumMargin: string;
  partnerRegularMarginAbs: string;
  partnerRelativeRegularMargin: string;
}

export type Status = 'loading' | 'ready' | 'saving';

export interface State {
  status: Status;
  edit: Edit;
}

type EditSetAction = { type: 'edit/set', payload: Edit };
type EditLoadedAction = { type: 'edit/loaded', payload: Edit };
type StatusSetAction = { type: 'status/set', payload: Status };
export type Action = EditSetAction | EditLoadedAction | StatusSetAction;

export const initialState: State = {
  status: 'loading',
  edit: {
    partnerDemandedMinimumMarginAbs: '',
    partnerRelativeDemandedMinimumMargin: '',
    partnerRegularMarginAbs: '',
    partnerRelativeRegularMargin: '',
  },
};

export function isMarginFilled(value: string): boolean {
  return value.trim() !== '';
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'edit/set': {
      return { ...state, edit: action.payload };
    }
    case 'edit/loaded': {
      return { ...state, status: 'ready', edit: action.payload };
    }
    case 'status/set': {
      return { ...state, status: action.payload };
    }
    default:
      return state;
  }
}
